import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-pause",
  "use": "icon_player-pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-pause\"><path stroke=\"currentColor\" stroke-linecap=\"round\" d=\"M18 20V4h-4v16h4ZM10 20V4H6v16h4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol